import {Directive, effect, inject, untracked} from '@angular/core';
import {Tabs} from 'primeng/tabs';
import {SaveButtonTrackingService} from '../project-step-save-button/save-button-tracking.service';

@Directive({
  selector: 'p-tabs[appTabsUnsavedReveal]',
})
export class TabsUnsavedRevealDirective {
  private readonly tabs = inject(Tabs);
  private readonly saveButtonTracking = inject(SaveButtonTrackingService);

  private handledRevealRequests = 0;

  constructor() {
    effect(() => this.activateTabWithUnsavedChanges());
  }

  private activateTabWithUnsavedChanges(): void {
    const revealRequests = this.saveButtonTracking.revealRequests();

    untracked(() => {
      if (revealRequests === this.handledRevealRequests) {
        return;
      }

      this.handledRevealRequests = revealRequests;

      const activeTabValue = String(this.tabs.value());

      if (this.saveButtonTracking.hasUnsavedChanges(this.tabs, activeTabValue)) {
        return;
      }

      const unsavedTabValue = this.saveButtonTracking.firstUnsavedTabValue(this.tabs);

      if (unsavedTabValue === undefined) {
        return;
      }

      this.tabs.value.set(this.toTabValue(unsavedTabValue));
    });
  }

  private toTabValue(tabValue: string): string | number {
    return typeof this.tabs.value() === 'number' ? Number(tabValue) : tabValue;
  }
}
